import script from "./SharePage.vue?vue&type=script&setup=true&lang=js"
export * from "./SharePage.vue?vue&type=script&setup=true&lang=js"

import "./SharePage.vue?vue&type=style&index=0&id=1df123d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df123d8"]])

export default __exports__